"use client"

import { useState } from "react"
import "./DemoForm.css"

function DemoForm({ onSubmit, onClose }) {
  const [formData, setFormData] = useState({
    fullName: "",
    businessEmail: "",
    jobTitle: "",
    company: "",
    contactNo: "",
    country: "",
    agreeToTerms: false,
  })

  const [errors, setErrors] = useState({})

  const countries = [
    "United States",
    "United Kingdom",
    "Canada",
    "Australia",
    "Germany",
    "France",
    "India",
    "Japan",
    "Brazil",
    "Mexico",
  ]

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }))

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }))
    }
  }

  const validateForm = () => {
    const newErrors = {}

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full name is required"
    }

    if (!formData.businessEmail.trim()) {
      newErrors.businessEmail = "Business email is required"
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.businessEmail)) {
      newErrors.businessEmail = "Please enter a valid email address"
    }

    if (!formData.jobTitle.trim()) {
      newErrors.jobTitle = "Job title is required"
    }

    if (!formData.company.trim()) {
      newErrors.company = "Company is required"
    }

    if (!formData.country) {
      newErrors.country = "Country is required"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (validateForm()) {
      onSubmit?.(formData)
      // Reset form
      setFormData({
        fullName: "",
        businessEmail: "",
        jobTitle: "",
        company: "",
        contactNo: "",
        country: "",
        agreeToTerms: false,
      })
      onClose?.()
    }
  }

  return (
    <div className="demo-container">
      <h2 className="demo-title">Schedule a Demo</h2>

      <form onSubmit={handleSubmit} className="demo-form">
        <div className="form-group">
          <input
            type="text"
            name="fullName"
            placeholder="Full Name*"
            value={formData.fullName}
            onChange={handleInputChange}
            className={`input ${errors.fullName ? "input-error" : ""}`}
          />
          {errors.fullName && <span className="error-text">{errors.fullName}</span>}
        </div>

        <div className="form-group">
          <input
            type="email"
            name="businessEmail"
            placeholder="Business Email*"
            value={formData.businessEmail}
            onChange={handleInputChange}
            className={`input ${errors.businessEmail ? "input-error" : ""}`}
          />
          {errors.businessEmail && <span className="error-text">{errors.businessEmail}</span>}
        </div>

        <div className="form-row">
          <div className="form-group">
            <input
              type="text"
              name="jobTitle"
              placeholder="Job Title*"
              value={formData.jobTitle}
              onChange={handleInputChange}
              className={`input ${errors.jobTitle ? "input-error" : ""}`}
            />
            {errors.jobTitle && <span className="error-text">{errors.jobTitle}</span>}
          </div>

          <div className="form-group">
            <input
              type="text"
              name="company"
              placeholder="Company*"
              value={formData.company}
              onChange={handleInputChange}
              className={`input ${errors.company ? "input-error" : ""}`}
            />
            {errors.company && <span className="error-text">{errors.company}</span>}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <input
              type="tel"
              name="contactNo"
              placeholder="Contact No"
              value={formData.contactNo}
              onChange={handleInputChange}
              className="input"
            />
          </div>

          <div className="form-group">
            <select
              name="country"
              value={formData.country}
              onChange={handleInputChange}
              className={`select ${errors.country ? "input-error" : ""}`}
            >
              <option value="">Country*</option>
              {countries.map((country) => (
                <option key={country} value={country}>
                  {country}
                </option>
              ))}
            </select>
            {errors.country && <span className="error-text">{errors.country}</span>}
          </div>
        </div>

        <div className="checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="agreeToTerms"
              checked={formData.agreeToTerms}
              onChange={handleInputChange}
              className="checkbox"
            />
            <span className="checkbox-text">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio.
            </span>
          </label>
        </div>

        <button type="submit" className="submit-button">
          Submit
        </button>
      </form>
    </div>
  )
}

export default DemoForm
